import schedule from './schedule'

export default {
  get: {
    method: 'get',
    url: '/p/journey/ID'
  },
  getVehicles: {
    method: 'get',
    url: '/p/journey/vehicles'
  },
  getJourneys: {
    method: 'get',
    url: '/p/journey/list'
  },
  schedule
}
